import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { SiteLogo } from "@/components/icons/SiteLogo";
import Trans from "@/components/Trans/Trans";

type GalleryEmptyStateProps = {
  testId: string;
};

// A tile-sized card in the first grid cell, as in the design, so the empty gallery keeps the grid's rhythm.
// Sized to match only the image area of a real tile (aspect-[4/5], same as MediaFilePreview) — there is no
// metadata row here, since there is no file to report on.
const GalleryEmptyState = ({ testId }: GalleryEmptyStateProps) => (
  <div
    data-testid={testId}
    className="flex aspect-[4/5] w-full flex-col items-center justify-center gap-4 rounded-2xl bg-gray-3 px-4 py-6 text-center text-gray-12 md:px-6 md:py-0"
  >
    <SiteLogo type="icon" className="h-12 w-12 md:h-14 md:w-14" />
    {/* Text defaults to left-aligned regardless of an ancestor's text-center, so centering is set here explicitly. */}
    <div className="flex flex-col gap-2">
      <Text variant={TextVariants.HEADING_6_BOLD} centered>
        <Trans i18nKey="gallery:emptyState.title" />
      </Text>
      <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className="text-gray-11" centered>
        <Trans i18nKey="gallery:emptyState.description" />
      </Text>
    </div>
  </div>
);

export default GalleryEmptyState;
